// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rtl-switcher {
  position: fixed;
  bottom: 15px;
  right: 15px;
  z-index: 999;
  border: none;
  background-color: #2962ff;
  color: #fff;
  padding: 5px 15px;
  font-size: 13px;
  display: inline-block;
}

[dir=rtl] .rtl-switcher {
  right: auto;
  left: 15px;
}
[dir=rtl] .ms-auto {
  margin-left: 0 !important;
  margin-right: auto !important;
}
[dir=rtl] .top-menu .burger-menu {
  margin-left: 0;
  margin-right: 70px;
}
[dir=rtl] .top-menu .mega-menu .dropdown-menu .title {
  text-align: right;
}
[dir=rtl] .top-menu .dropdown-item {
  text-align: right;
}
[dir=rtl] .top-menu .nav-search-form .search-success {
  right: auto;
  left: 0;
}
[dir=rtl] .top-menu .right-nav .dropdown-menu {
  left: 5px;
  right: auto;
}
[dir=rtl] .top-menu .message-item {
  padding-left: 0;
  padding-right: 45px;
  text-align: right;
}
[dir=rtl] .top-menu .message-item .user-pic {
  left: auto;
  right: 0;
}
[dir=rtl] .top-menu .profile-nav-item .dropdown-item .icon {
  margin-right: 0;
  margin-left: 5px;
}
[dir=rtl] .top-menu .profile-nav-item .menu-profile img {
  margin-left: 0;
  margin-right: 8px;
}
[dir=rtl] .side-menu-switch {
  right: auto;
  left: 15px;
}
[dir=rtl] .dropdown-menu {
  left: auto;
  right: 0;
}
[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .nav-link .title {
  padding-left: 0;
  padding-right: 10px;
}
[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .nav-link .title .icon.fr {
  right: auto;
  left: 0;
}
[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .active::before {
  right: auto;
  left: -18px;
  transform: rotate(45deg);
}
[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .dropdown-menu .dropdown-item {
  text-align: right;
}
[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .dropdown-menu .dropdown-item .icon {
  margin-right: 0;
  margin-left: 8px;
}
[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .dropdown-menu .dropdown-item.drpMenu::before {
  right: auto;
  left: -18px;
  transform: rotate(45deg);
}
@media only screen and (min-width: 768px) {
  [dir=rtl] .sidemenu .dropdown .dropdown-menu {
    left: -200px;
    right: auto;
  }
}
[dir=rtl] .main-content {
  padding-left: 15px;
  padding-right: 250px;
}
[dir=rtl] .sidemenu-area {
  left: auto;
  right: 0;
}
[dir=rtl] .main-content-header h1 {
  padding-right: 0;
  padding-left: 15px;
}
[dir=rtl] .main-content-header .breadcrumb .breadcrumb-item {
  padding-left: 0;
  padding-right: 15px;
}
[dir=rtl] .main-content-header .breadcrumb .breadcrumb-item::before {
  float: right;
  padding-left: 10px;
  padding-right: 0;
}
[dir=rtl] .main-content-header .breadcrumb .breadcrumb-item:first-child {
  padding-right: 0;
}
[dir=rtl] .stats-card i {
  right: auto;
  left: 0;
  border-radius: 0 30px 30px 30px;
}
[dir=rtl] .stats-card h3 .icon {
  margin-left: 0;
  margin-right: 5px;
}
[dir=rtl] .card .card-header::before {
  left: auto;
  right: 0;
}
[dir=rtl] .top-rated-products .single-product {
  padding-left: 45px;
  padding-right: 80px;
}
[dir=rtl] .top-rated-products .single-product img {
  left: auto;
  right: 0;
}
[dir=rtl] .top-rated-products .single-product .view-link {
  left: 10px;
  right: auto;
}
[dir=rtl] .card .card-header .day {
  right: auto;
  left: 0;
}
[dir=rtl] .apexcharts-legend-marker {
  margin-right: 0;
  margin-left: 3px;
}
[dir=rtl] .new-customer {
  padding-left: 0;
  padding-right: 52px;
}
[dir=rtl] .new-customer .profile {
  left: auto;
  right: 0;
}
[dir=rtl] .new-customer .price {
  right: auto;
  left: 0;
}
[dir=rtl] .me-2 {
  margin-right: 0 !important;
  margin-left: 0.5rem !important;
}
[dir=rtl] .marketing-content .list {
  padding-left: 0;
  padding-right: 50px;
}
[dir=rtl] .marketing-content .list > .icon {
  left: auto;
  right: 0;
}
[dir=rtl] .marketing-content .list .stats {
  right: auto;
  left: 0;
}
[dir=rtl] .marketing-content .list .stats .icon {
  margin-right: 0;
  margin-left: 8px;
}
[dir=rtl] .card-header .select-month-form {
  right: auto;
  left: 0;
}
[dir=rtl] .tickets-lists li {
  padding-left: 40px;
  padding-right: 65px;
}
[dir=rtl] .tickets-lists li img {
  left: auto;
  right: 0;
}
[dir=rtl] .mr-10 {
  margin-right: 0;
  margin-left: 10px;
}
[dir=rtl] .mr-5 {
  margin-right: 0 !important;
  margin-left: 5px !important;
}
[dir=rtl] .product-categories li {
  padding-left: 106px;
  padding-right: 16px;
}
[dir=rtl] .product-categories li::before {
  left: auto;
  right: 0;
}
[dir=rtl] .email-details-warp .inbox-topbar {
  right: auto;
  left: 30px;
}
[dir=rtl] .me-1 {
  margin-right: 0 !important;
  margin-left: 0.25rem !important;
}
[dir=rtl] .fr {
  float: left;
}
[dir=rtl] .mail-item-nav .nav-pills .nav-link .info {
  padding-left: 0;
  padding-right: 40px;
}
[dir=rtl] .mail-item-nav .nav-pills .nav-link .info .date {
  right: auto;
  left: 15px;
}
[dir=rtl] .chat-list-right .chat-details .date {
  right: auto;
  left: 20px;
}
[dir=rtl] .chat-list-left .chat-details .date {
  right: auto;
  left: 20px;
}
[dir=rtl] .todo-list .add-new-task .btn-primary {
  right: auto;
  left: 0;
}
[dir=rtl] .todo-list ul .close-btn {
  right: auto;
  left: 15px;
}
[dir=rtl] .todo-list .control {
  left: auto;
  right: 30px;
}
[dir=rtl] .list-group, [dir=rtl] .nav-tabs {
  padding-right: 0;
}
[dir=rtl] .ms-3 {
  margin-left: 0 !important;
  margin-right: 1rem !important;
}
[dir=rtl] .me-3 {
  margin-right: 0 !important;
  margin-left: 1rem !important;
}
[dir=rtl] .custom-accordion .accordion__button {
  text-align: right;
}
[dir=rtl] .custom-accordion .accordion__button::before {
  margin-right: 0;
  margin-left: 10px;
}
[dir=rtl] .profile-left-content .info li {
  padding-left: 0;
  padding-right: 20px;
}
[dir=rtl] .profile-left-content .info li .icon {
  left: auto;
  right: 0;
}
[dir=rtl] .post-card .feed-back a {
  margin-right: 0;
  margin-left: 15px;
  padding-right: 0;
  padding-left: 10px;
}
[dir=rtl] .post-card .feed-back a .icon {
  margin-right: 0;
  margin-left: 5px;
}
@media only screen and (max-width: 767px) {
  [dir=rtl] .top-menu .burger-menu {
    margin-right: 0;
  }
  [dir=rtl] .top-menu .profile-nav-item .menu-profile img {
    margin-left: 0;
    margin-right: 0;
  }
  [dir=rtl] .top-menu .message-box .dropdown-menu {
    min-width: 215px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 768px) {
  [dir=rtl] .top-menu .nav-search-form {
    margin-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  [dir=rtl] .main-content {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  [dir=rtl] .main-content {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 1200px) {
  [dir=rtl] .hide-sidemenu {
    padding-left: 0;
    padding-right: 87px;
  }
  [dir=rtl] .sidemenu-toggle:hover .nav-link {
    text-align: right;
  }
}
@media only screen and (max-width: 1199px) {
  [dir=rtl] .sidemenu-area {
    right: -100%;
  }
  [dir=rtl] .sidemenu-area.sidemenu-toggle {
    right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/rtl.scss","webpack://./src/assets/css/rtl.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;ACCF;;ADGE;EACE,WAAA;EACA,UAAA;ACAJ;ADIE;EACE,yBAAA;EACA,6BAAA;ACFJ;ADMI;EACE,cAAA;EACA,kBAAA;ACJN;ADQQ;EACE,iBAAA;ACNV;ADUI;EACE,iBAAA;ACRN;ADWM;EACE,WAAA;EACA,OAAA;ACTR;ADcM;EACE,SAAA;EACA,WAAA;ACZR;ADgBI;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;ACdN;ADgBM;EACE,UAAA;EACA,QAAA;ACdR;ADoBQ;EACE,eAAA;EACA,gBAAA;AClBV;ADsBQ;EACE,cAAA;EACA,iBAAA;ACpBV;AD0BE;EACE,WAAA;EACA,UAAA;ACxBJ;AD2BE;EACE,UAAA;EACA,QAAA;ACzBJ;ADgCU;EACE,eAAA;EACA,mBAAA;AC9BZ;ADgCY;EACE,WAAA;EACA,OAAA;AC9Bd;ADmCU;EACE,WAAA;EACA,WAAA;EACA,wBAAA;ACjCZ;ADqCU;EACE,iBAAA;ACnCZ;ADqCY;EACE,eAAA;EACA,gBAAA;ACnCd;ADuCc;EACE,WAAA;EACA,WAAA;EACA,wBAAA;ACrChB;AD8CE;EAGM;IACE,YAAA;IACA,WAAA;EC9CR;AACF;ADmDE;EACE,kBAAA;EACA,oBAAA;ACjDJ;ADmDE;EACE,UAAA;EACA,QAAA;ACjDJ;ADqDI;EACE,gBAAA;EACA,kBAAA;ACnDN;ADsDM;EACE,eAAA;EACA,mBAAA;ACpDR;ADsDQ;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;ACpDV;ADuDQ;EACE,gBAAA;ACrDV;AD4DI;EACE,WAAA;EACA,OAAA;EACA,+BAAA;AC1DN;AD6DM;EACE,cAAA;EACA,iBAAA;AC3DR;ADkEM;EACE,UAAA;EACA,QAAA;AChER;ADsEI;EACE,kBAAA;EACA,mBAAA;ACpEN;ADsEM;EACE,UAAA;EACA,QAAA;ACpER;ADsEM;EACE,UAAA;EACA,WAAA;ACpER;AD2EM;EACE,WAAA;EACA,OAAA;ACzER;AD8EE;EACE,eAAA;EACA,gBAAA;AC5EJ;AD+EE;EACE,eAAA;EACA,mBAAA;AC7EJ;AD+EI;EACE,UAAA;EACA,QAAA;AC7EN;AD+EI;EACE,WAAA;EACA,OAAA;AC7EN;ADiFE;EACE,0BAAA;EACA,8BAAA;AC/EJ;ADmFI;EACE,eAAA;EACA,mBAAA;ACjFN;ADmFM;EACE,UAAA;EACA,QAAA;ACjFR;ADmFM;EACE,WAAA;EACA,OAAA;ACjFR;ADmFQ;EACE,eAAA;EACA,gBAAA;ACjFV;ADwFI;EACE,WAAA;EACA,OAAA;ACtFN;AD2FI;EACE,kBAAA;EACA,mBAAA;ACzFN;AD2FM;EACE,UAAA;EACA,QAAA;ACzFR;AD8FE;EACE,eAAA;EACA,iBAAA;AC5FJ;AD8FE;EACE,0BAAA;EACA,2BAAA;AC5FJ;ADgGI;EACE,mBAAA;EACA,mBAAA;AC9FN;ADgGM;EACE,UAAA;EACA,QAAA;AC9FR;ADoGI;EACE,WAAA;EACA,UAAA;AClGN;ADsGE;EACE,0BAAA;EACA,+BAAA;ACpGJ;ADsGE;EACE,WAAA;ACpGJ;ADyGQ;EACE,eAAA;EACA,mBAAA;ACvGV;ADyGU;EACE,WAAA;EACA,UAAA;ACvGZ;ADgHM;EACE,WAAA;EACA,UAAA;AC9GR;ADoHM;EACE,WAAA;EACA,UAAA;AClHR;ADyHM;EACE,WAAA;EACA,OAAA;ACvHR;AD4HM;EACE,WAAA;EACA,UAAA;AC1HR;AD6HI;EACE,UAAA;EACA,WAAA;AC3HN;AD+HE;EACE,gBAAA;AC7HJ;ADgIE;EACE,yBAAA;EACA,6BAAA;AC9HJ;ADgIE;EACE,0BAAA;EACA,4BAAA;AC9HJ;ADkII;EACE,iBAAA;AChIN;ADkIM;EACE,eAAA;EACA,iBAAA;AChIR;ADuIM;EACE,eAAA;EACA,mBAAA;ACrIR;ADuIQ;EACE,UAAA;EACA,QAAA;ACrIV;AD6IM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AC3IR;AD6IQ;EACE,eAAA;EACA,gBAAA;AC3IV;ADwJE;EAEI;IACE,eAAA;ECvJN;ED2JQ;IACE,cAAA;IACA,eAAA;ECzJV;ED8JM;IACE,gBAAA;EC5JR;AACF;ADiKE;EAEI;IACE,kBAAA;EChKN;AACF;ADqKE;EACE;IACE,kBAAA;IACA,mBAAA;ECnKJ;AACF;ADsKE;EACE;IACE,kBAAA;IACA,mBAAA;ECpKJ;AACF;ADuKE;EACE;IACE,eAAA;IACA,mBAAA;ECrKJ;EDyKM;IACE,iBAAA;ECvKR;AACF;AD4KE;EACE;IACE,YAAA;EC1KJ;ED4KI;IACE,QAAA;EC1KN;AACF","sourcesContent":[".rtl-switcher {\n  position: fixed;\n  bottom: 15px;\n  right: 15px;\n  z-index: 999;\n  border: none;\n  background-color: #2962ff;\n  color: #fff;\n  padding: 5px 15px;\n  font-size: 13px;\n  display: inline-block;\n}\n\n[dir=\"rtl\"] {\n  .rtl-switcher { \n    right: auto; \n    left: 15px; \n  }\n  \n\n  .ms-auto {\n    margin-left: 0 !important;\n    margin-right: auto !important;\n  }\n \n  .top-menu {\n    .burger-menu { \n      margin-left: 0; \n      margin-right: 70px; \n    }\n    .mega-menu {\n      .dropdown-menu {\n        .title {\n          text-align: right;\n        } \n      }\n    }\n    .dropdown-item {\n      text-align: right;\n    }\n    .nav-search-form {\n      .search-success {\n        right: auto; \n        left: 0; \n      }\n    }\n\n    .right-nav {\n      .dropdown-menu {\n        left: 5px;\n        right: auto;\n      }\n    }\n \n    .message-item {\n      padding-left: 0;\n      padding-right: 45px;\n      text-align: right;\n\n      .user-pic {\n        left: auto; \n        right: 0; \n      }\n    }\n\n    .profile-nav-item {\n      .dropdown-item {\n        .icon {\n          margin-right: 0;\n          margin-left: 5px;\n        }\n      }\n      .menu-profile {\n        img {\n          margin-left: 0;\n          margin-right: 8px;\n        }\n      }\n    }\n  }\n \n  .side-menu-switch {\n    right: auto;\n    left: 15px;\n  }\n\n  .dropdown-menu {\n    left: auto;\n    right: 0;\n  }\n\n  .sidemenu-area {\n    .sidemenu {\n      .navbar-nav {\n        .nav-link {\n          .title {\n            padding-left: 0;\n            padding-right: 10px;\n\n            .icon.fr {\n              right: auto;\n              left: 0;\n            }\n          }\n        }\n        .active {\n          &::before {\n            right: auto;\n            left: -18px;\n            transform: rotate(45deg);\n          }\n        }\n        .dropdown-menu {\n          .dropdown-item {\n            text-align: right;\n\n            .icon {\n              margin-right: 0; \n              margin-left: 8px; \n            }\n\n            &.drpMenu {\n              &::before {\n                right: auto;\n                left: -18px;\n                transform: rotate(45deg);\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media only screen and (min-width: 768px) {\n    .sidemenu {\n      .dropdown {\n        .dropdown-menu {\n          left: -200px;\n          right: auto;\n        }\n      }\n    }\n  }\n   \n  .main-content {\n    padding-left: 15px; \n    padding-right: 250px; \n  }\n  .sidemenu-area {\n    left: auto; \n    right: 0; \n  }\n\n  .main-content-header {\n    h1 {\n      padding-right: 0;\n      padding-left: 15px;\n    }\n    .breadcrumb {\n      .breadcrumb-item {\n        padding-left: 0;\n        padding-right: 15px;\n\n        &::before {\n          float: right;\n          padding-left: 10px;\n          padding-right: 0;\n        }\n\n        &:first-child {\n          padding-right: 0;\n        }\n      }\n    }\n  }\n\n  .stats-card {\n    i { \n      right: auto;\n      left: 0;\n      border-radius: 0 30px 30px 30px;\n    }\n    h3 {\n      .icon {\n        margin-left: 0;\n        margin-right: 5px;\n      }\n    }\n  }\n\n  .card {\n    .card-header {\n      &::before {\n        left: auto; \n        right: 0; \n      }\n    }\n  }\n\n  .top-rated-products {\n    .single-product {\n      padding-left: 45px;\n      padding-right: 80px;\n\n      img {\n        left: auto;\n        right: 0;\n      }\n      .view-link {\n        left: 10px;\n        right: auto;\n      }\n    }\n  }\n\n  .card {\n    .card-header {\n      .day {\n        right: auto; \n        left: 0; \n      }\n    }\n  }\n\n  .apexcharts-legend-marker {\n    margin-right: 0; \n    margin-left: 3px; \n  }\n\n  .new-customer { \n    padding-left: 0; \n    padding-right: 52px; \n\n    .profile {\n      left: auto;\n      right: 0;\n    }\n    .price {\n      right: auto; \n      left: 0; \n    }\n  }\n\n  .me-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .marketing-content {\n    .list { \n      padding-left: 0; \n      padding-right: 50px; \n\n      > .icon {\n        left: auto;\n        right: 0;\n      }\n      .stats {\n        right: auto; \n        left: 0; \n\n        .icon {\n          margin-right: 0;\n          margin-left: 8px;\n        }\n      }\n    }\n  }\n\n  .card-header {\n    .select-month-form {\n      right: auto; \n      left: 0; \n    }\n  }\n\n  .tickets-lists {\n    li {\n      padding-left: 40px;\n      padding-right: 65px;\n\n      img {\n        left: auto;\n        right: 0;\n      }\n    }\n  }\n\n  .mr-10 {\n    margin-right: 0;\n    margin-left: 10px;\n  }\n  .mr-5 {\n    margin-right: 0 !important;\n    margin-left: 5px !important;\n  }\n\n  .product-categories {\n    li {\n      padding-left: 106px;\n      padding-right: 16px;\n\n      &::before {\n        left: auto;\n        right: 0;\n      }\n    }\n  }\n\n  .email-details-warp {\n    .inbox-topbar {\n      right: auto;\n      left: 30px;\n    }\n  }\n\n  .me-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n  .fr {\n    float: left;\n  }\n  .mail-item-nav {\n    .nav-pills {\n      .nav-link {\n        .info {\n          padding-left: 0;\n          padding-right: 40px;\n\n          .date {\n            right: auto;\n            left: 15px;\n          }\n        }\n      }\n    }\n  }\n\n  .chat-list-right {\n    .chat-details {\n      .date {\n        right: auto; \n        left: 20px; \n      }\n    }\n  }\n  .chat-list-left {\n    .chat-details {\n      .date {\n        right: auto; \n        left: 20px; \n      }\n    }\n  }\n  \n  .todo-list {\n    .add-new-task {\n      .btn-primary {\n        right: auto; \n        left: 0; \n      }\n    }\n\n    ul {\n      .close-btn {\n        right: auto; \n        left: 15px; \n      }\n    }\n    .control { \n      left: auto; \n      right: 30px; \n    }\n  }\n\n  .list-group, .nav-tabs {\n    padding-right: 0;\n  }\n\n  .ms-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n  .me-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .custom-accordion {\n    .accordion__button {\n      text-align: right;\n\n      &::before {\n        margin-right: 0;\n        margin-left: 10px;\n      }\n    }\n  }\n\n  .profile-left-content {\n    .info {\n      li {\n        padding-left: 0; \n        padding-right: 20px; \n\n        .icon {\n          left: auto;\n          right: 0;\n        }\n      }\n    }\n  }\n\n  .post-card {\n    .feed-back {\n      a { \n        margin-right: 0; \n        margin-left: 15px; \n        padding-right: 0; \n        padding-left: 10px; \n\n        .icon {\n          margin-right: 0;\n          margin-left: 5px;\n        }\n      }\n    }\n  }\n\n\n\n\n\n\n\n  // Responsive CSS\n  @media only screen and (max-width: 767px) {\n    .top-menu {\n      .burger-menu {\n        margin-right: 0;\n      }\n      .profile-nav-item {\n        .menu-profile {\n          img {\n            margin-left: 0;\n            margin-right: 0;\n          }\n        }\n      }\n      .message-box {\n        .dropdown-menu {\n          min-width: 215px;\n        }\n      }\n    }\n  }\n\n  @media only screen and (min-width : 576px) and (max-width : 768px) {\n    .top-menu {\n      .nav-search-form {\n        margin-right: 15px;\n      }\n    }\n  }\n\n\n  @media only screen and (min-width : 768px) and (max-width : 991px) {\n    .main-content {\n      padding-left: 15px;\n      padding-right: 15px;\n    }\n  }\n\n  @media only screen and (min-width : 992px) and (max-width : 1199px) {\n    .main-content {\n      padding-left: 15px;\n      padding-right: 15px;\n    }\n  }\n \n  @media only screen and (min-width: 1200px) {\n    .hide-sidemenu {\n      padding-left: 0;\n      padding-right: 87px;\n    }\n    .sidemenu-toggle {\n      &:hover {\n        .nav-link {\n          text-align: right;\n        }\n      }\n    }\n  }\n\n  @media only screen and (max-width: 1199px) {\n    .sidemenu-area {\n      right: -100%; \n\n      &.sidemenu-toggle {\n        right: 0;\n      }\n    }\n  }\n\n}",".rtl-switcher {\n  position: fixed;\n  bottom: 15px;\n  right: 15px;\n  z-index: 999;\n  border: none;\n  background-color: #2962ff;\n  color: #fff;\n  padding: 5px 15px;\n  font-size: 13px;\n  display: inline-block;\n}\n\n[dir=rtl] .rtl-switcher {\n  right: auto;\n  left: 15px;\n}\n[dir=rtl] .ms-auto {\n  margin-left: 0 !important;\n  margin-right: auto !important;\n}\n[dir=rtl] .top-menu .burger-menu {\n  margin-left: 0;\n  margin-right: 70px;\n}\n[dir=rtl] .top-menu .mega-menu .dropdown-menu .title {\n  text-align: right;\n}\n[dir=rtl] .top-menu .dropdown-item {\n  text-align: right;\n}\n[dir=rtl] .top-menu .nav-search-form .search-success {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .top-menu .right-nav .dropdown-menu {\n  left: 5px;\n  right: auto;\n}\n[dir=rtl] .top-menu .message-item {\n  padding-left: 0;\n  padding-right: 45px;\n  text-align: right;\n}\n[dir=rtl] .top-menu .message-item .user-pic {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .top-menu .profile-nav-item .dropdown-item .icon {\n  margin-right: 0;\n  margin-left: 5px;\n}\n[dir=rtl] .top-menu .profile-nav-item .menu-profile img {\n  margin-left: 0;\n  margin-right: 8px;\n}\n[dir=rtl] .side-menu-switch {\n  right: auto;\n  left: 15px;\n}\n[dir=rtl] .dropdown-menu {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .nav-link .title {\n  padding-left: 0;\n  padding-right: 10px;\n}\n[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .nav-link .title .icon.fr {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .active::before {\n  right: auto;\n  left: -18px;\n  transform: rotate(45deg);\n}\n[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .dropdown-menu .dropdown-item {\n  text-align: right;\n}\n[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .dropdown-menu .dropdown-item .icon {\n  margin-right: 0;\n  margin-left: 8px;\n}\n[dir=rtl] .sidemenu-area .sidemenu .navbar-nav .dropdown-menu .dropdown-item.drpMenu::before {\n  right: auto;\n  left: -18px;\n  transform: rotate(45deg);\n}\n@media only screen and (min-width: 768px) {\n  [dir=rtl] .sidemenu .dropdown .dropdown-menu {\n    left: -200px;\n    right: auto;\n  }\n}\n[dir=rtl] .main-content {\n  padding-left: 15px;\n  padding-right: 250px;\n}\n[dir=rtl] .sidemenu-area {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .main-content-header h1 {\n  padding-right: 0;\n  padding-left: 15px;\n}\n[dir=rtl] .main-content-header .breadcrumb .breadcrumb-item {\n  padding-left: 0;\n  padding-right: 15px;\n}\n[dir=rtl] .main-content-header .breadcrumb .breadcrumb-item::before {\n  float: right;\n  padding-left: 10px;\n  padding-right: 0;\n}\n[dir=rtl] .main-content-header .breadcrumb .breadcrumb-item:first-child {\n  padding-right: 0;\n}\n[dir=rtl] .stats-card i {\n  right: auto;\n  left: 0;\n  border-radius: 0 30px 30px 30px;\n}\n[dir=rtl] .stats-card h3 .icon {\n  margin-left: 0;\n  margin-right: 5px;\n}\n[dir=rtl] .card .card-header::before {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .top-rated-products .single-product {\n  padding-left: 45px;\n  padding-right: 80px;\n}\n[dir=rtl] .top-rated-products .single-product img {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .top-rated-products .single-product .view-link {\n  left: 10px;\n  right: auto;\n}\n[dir=rtl] .card .card-header .day {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .apexcharts-legend-marker {\n  margin-right: 0;\n  margin-left: 3px;\n}\n[dir=rtl] .new-customer {\n  padding-left: 0;\n  padding-right: 52px;\n}\n[dir=rtl] .new-customer .profile {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .new-customer .price {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .me-2 {\n  margin-right: 0 !important;\n  margin-left: 0.5rem !important;\n}\n[dir=rtl] .marketing-content .list {\n  padding-left: 0;\n  padding-right: 50px;\n}\n[dir=rtl] .marketing-content .list > .icon {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .marketing-content .list .stats {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .marketing-content .list .stats .icon {\n  margin-right: 0;\n  margin-left: 8px;\n}\n[dir=rtl] .card-header .select-month-form {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .tickets-lists li {\n  padding-left: 40px;\n  padding-right: 65px;\n}\n[dir=rtl] .tickets-lists li img {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .mr-10 {\n  margin-right: 0;\n  margin-left: 10px;\n}\n[dir=rtl] .mr-5 {\n  margin-right: 0 !important;\n  margin-left: 5px !important;\n}\n[dir=rtl] .product-categories li {\n  padding-left: 106px;\n  padding-right: 16px;\n}\n[dir=rtl] .product-categories li::before {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .email-details-warp .inbox-topbar {\n  right: auto;\n  left: 30px;\n}\n[dir=rtl] .me-1 {\n  margin-right: 0 !important;\n  margin-left: 0.25rem !important;\n}\n[dir=rtl] .fr {\n  float: left;\n}\n[dir=rtl] .mail-item-nav .nav-pills .nav-link .info {\n  padding-left: 0;\n  padding-right: 40px;\n}\n[dir=rtl] .mail-item-nav .nav-pills .nav-link .info .date {\n  right: auto;\n  left: 15px;\n}\n[dir=rtl] .chat-list-right .chat-details .date {\n  right: auto;\n  left: 20px;\n}\n[dir=rtl] .chat-list-left .chat-details .date {\n  right: auto;\n  left: 20px;\n}\n[dir=rtl] .todo-list .add-new-task .btn-primary {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .todo-list ul .close-btn {\n  right: auto;\n  left: 15px;\n}\n[dir=rtl] .todo-list .control {\n  left: auto;\n  right: 30px;\n}\n[dir=rtl] .list-group, [dir=rtl] .nav-tabs {\n  padding-right: 0;\n}\n[dir=rtl] .ms-3 {\n  margin-left: 0 !important;\n  margin-right: 1rem !important;\n}\n[dir=rtl] .me-3 {\n  margin-right: 0 !important;\n  margin-left: 1rem !important;\n}\n[dir=rtl] .custom-accordion .accordion__button {\n  text-align: right;\n}\n[dir=rtl] .custom-accordion .accordion__button::before {\n  margin-right: 0;\n  margin-left: 10px;\n}\n[dir=rtl] .profile-left-content .info li {\n  padding-left: 0;\n  padding-right: 20px;\n}\n[dir=rtl] .profile-left-content .info li .icon {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .post-card .feed-back a {\n  margin-right: 0;\n  margin-left: 15px;\n  padding-right: 0;\n  padding-left: 10px;\n}\n[dir=rtl] .post-card .feed-back a .icon {\n  margin-right: 0;\n  margin-left: 5px;\n}\n@media only screen and (max-width: 767px) {\n  [dir=rtl] .top-menu .burger-menu {\n    margin-right: 0;\n  }\n  [dir=rtl] .top-menu .profile-nav-item .menu-profile img {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  [dir=rtl] .top-menu .message-box .dropdown-menu {\n    min-width: 215px;\n  }\n}\n@media only screen and (min-width: 576px) and (max-width: 768px) {\n  [dir=rtl] .top-menu .nav-search-form {\n    margin-right: 15px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  [dir=rtl] .main-content {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n}\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  [dir=rtl] .main-content {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  [dir=rtl] .hide-sidemenu {\n    padding-left: 0;\n    padding-right: 87px;\n  }\n  [dir=rtl] .sidemenu-toggle:hover .nav-link {\n    text-align: right;\n  }\n}\n@media only screen and (max-width: 1199px) {\n  [dir=rtl] .sidemenu-area {\n    right: -100%;\n  }\n  [dir=rtl] .sidemenu-area.sidemenu-toggle {\n    right: 0;\n  }\n}/*# sourceMappingURL=rtl.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
